import { defineMessages } from 'react-intl';

export default defineMessages({
	playButton: {
		id: 'programActions.playButton',
		defaultMessage: 'Play',
		description: 'A button to play the current Calm Masterclass',
	},
	watchTrailerButton: {
		id: 'programActions.watchTrailerButton',
		defaultMessage: 'Watch Trailer',
		description: 'A button to watch the trailer for the current Calm Masterclass (a video)',
	},
});
